export default "__VITE_ASSET__DVb88aq7__"